export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20architectural%20composition%20with%20warm%20amber%20gold%20and%20cream%20tones%2C%20flowing%20organic%20lines%20intersecting%20with%20structured%20grid%20elements%2C%20soft%20gradient%20lighting%20from%20top%20left%2C%20sophisticated%20professional%20atmosphere%2C%20no%20text%20no%20human%20figures%2C%20digital%20art%20style%2C%20clean%20and%20elegant%20composition&width=1800&height=1200&seq=hero-bg-something-digital&orientation=landscape"
          alt="Abstract geometric architectural composition"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center pt-32 pb-20">
        <div className="w-24 h-px bg-primary-500/60 mx-auto mb-10"></div>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-light text-background-50 tracking-wide leading-tight">
          (Something Digital d.o.o.)
        </h1>
        <div className="w-16 h-px bg-primary-500/50 mx-auto mt-10 mb-12"></div>
        <p className="text-lg md:text-xl text-background-200/90 font-light max-w-3xl mx-auto leading-relaxed tracking-wide">
          A professional engineering team designing and developing modern digital
          software solutions for the iOS platform and related technologies
        </p>
      </div>
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-300/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-300/60 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}